<div class="info">
    <div class="title-1">{{ 'matching.info.foundMatch' | translate }}</div>
    <div class="title-2">{{ 'matching.info.selectTeacher' | translate }}</div>
</div>
